// VIZBI Showcase events, most recent first. Hero images consolidated in
// public/Showcase/ as <year>.<ext>; per-event images in public/Showcase/<year>/.
// Sources:
// - 2019, 2023–2026: src/assets/years/<year>/Showcase/Index.vue (venue text);
//   hero images originally from public/<year>/Showcase.* and
//   src/assets/years/2023/Showcase/img/banner.jpeg (2023).
// - 2013–2018 (Vivid Sydney / VizbiPlus era, plus the 2018 New York event):
//   migrated from legacy/Plus/Plus/{2014,2016,2017}/Events/index.shtml and
//   legacy/Plus/Plus/Events/index.shtml into
//   src/assets/years/<year>/Showcase/ (2018 has Sydney.vue and NewYork.vue).
//   The 2017 and 2018 banners come from the legacy site; 2014's is the Vimeo
//   thumbnail of "David Goodsell: Making Science Beautiful" (video
//   5bc47c14b5); the 2013, 2015, and 2016 heroes are images supplied by the
//   user (2026-08).
// `event` names the primary event each showcase was part of (if any);
// `title` is the showcase name, rendered verbatim in the /Showcases list.
export const headingFor = (showcase) => {
  const prefix = showcase.event ? `${showcase.event} ${showcase.year}` : showcase.year;
  return `${prefix} — ${showcase.title} ${showcase.venue}`;
};
export default [
  {
    year: "2026",
    event: "VIZBI",
    title: "'Twin Lenses on the Dance of Life'",
    venue: "The Hub, Cambridge, UK",
    image: "/Showcase/2026.jpg",
    link: "/2026/Showcase"
  },
  {
    year: "2025",
    event: "VIZBI",
    title: "'Art & Biology Showcase'",
    venue: "The Hub, Cambridge, UK",
    image: "/Showcase/2025.jpeg",
    link: "/2025/Showcase"
  },
  {
    year: "2024",
    event: "VIZBI",
    title: "'Inner Space' VR & 'Light on Earth' Film",
    venue: "The Bridge Institute, USC, Los Angeles, USA",
    image: "/Showcase/2024.png",
    link: "/2024/Showcase"
  },
  {
    year: "2023",
    event: "VIZBI",
    title: "'Unseen Natural History'",
    venue: "EMBL Heidelberg, Germany",
    image: "/Showcase/2023.jpeg",
    link: "/2023/Showcase"
  },
  {
    year: "2019",
    event: "VIZBI",
    title: "'Communicating Science Visually'",
    venue: "EMBL Heidelberg, Germany",
    image: "/Showcase/2019.jpg",
    link: "/2019/Showcase"
  },
  {
    year: "2018",
    event: "Vivid",
    title: "'Bridging Science, Art and Design'",
    venue: "Museum of Contemporary Art, Sydney, Australia",
    image: "/Showcase/2018.png",
    link: "/2018/Showcase/Sydney"
  },
  {
    year: "2018",
    event: "VIZBI",
    title: "'Science Reimagined'",
    venue: "New York Genome Center, New York, USA",
    image: "/Showcase/2018-NewYork.png",
    link: "/2018/Showcase/NewYork"
  },
  {
    year: "2017",
    event: "Vivid",
    title: "'Bridging Science with Art, Design & Animation'",
    venue: "Museum of Contemporary Art, Sydney, Australia",
    image: "/Showcase/2017.png",
    link: "/2017/Showcase/Evening"
  },
  {
    year: "2017",
    event: "Vivid",
    title: "'VizbiPlus Exhibit: A Showcase of Science-Inspired Artwork'",
    venue: "Spunky Bruiser Store, Darlinghurst, Sydney, Australia",
    image: "/Showcase/2017/fb_cover851by315.png",
    link: "/2017/Showcase/Exhibit"
  },
  {
    year: "2016",
    event: "Vivid",
    title: "'Visualising the Future of Biomedicine'",
    venue: "The Kinghorn Cancer Centre, Darlinghurst, Sydney, Australia",
    image: "/Showcase/2016.jpg",
    link: "/2016/Showcase"
  },
  {
    year: "2015",
    event: "Vivid",
    title: "'Science Reimagined'",
    venue: "Charles Perkins Centre, University of Sydney, Australia",
    image: "/Showcase/2015.jpg",
    link: "/2015/Showcase"
  },
  {
    year: "2014",
    event: "Vivid",
    title: "'Making Science Beautiful'",
    venue: "Museum of Contemporary Art, Sydney, Australia",
    image: "/Showcase/2014.jpg",
    link: "/2014/Showcase/MakingScienceBeautiful"
  },
  {
    year: "2014",
    event: "Vivid",
    title: "'Unlocking the Protein Data Bank' Masterclass",
    venue: "Museum of Contemporary Art, Sydney, Australia",
    image: "/Showcase/2014/DGoodsell_ecoli_large.jpg",
    link: "/2014/Showcase/Masterclass"
  },
  {
    year: "2014",
    event: null,
    title: "'VizbiPlus on the Big Screen'",
    venue: "Federation Square, Melbourne, Australia",
    image: "/Plus/Timeline/Federation-Square-Big-Screen-2.jpg",
    link: "/2014/Showcase/FederationSquare"
  },
  {
    year: "2013",
    event: "Vivid",
    title: "'Ten Commandments: Connect with Science'",
    venue: "Museum of Contemporary Art, Sydney, Australia",
    image: "/Showcase/2013.jpg",
    link: "/2013/Showcase"
  }
];
